import { adminAuth, adminRequest } from './adminAuth';
const withCsrf = async (path, body) => {
    const { csrfToken } = await adminAuth.csrf();
    return adminRequest(path, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrfToken },
        body: JSON.stringify(body)
    });
};
const customerFields = (input) => ({
    fullName: input.fullName,
    email: input.email,
    primaryPhone: input.primaryPhone,
    secondaryPhone: input.secondaryPhone,
    address: input.address,
    planCode: input.planCode,
    customPlanName: input.customPlanName,
    salesStatus: input.salesStatus,
    enrollmentEndDate: input.enrollmentEndDate,
    lastContactDate: input.lastContactDate,
    details: input.details
});
export const adminCustomers = {
    list: (query) => {
        const parameters = new URLSearchParams({
            page: String(query.page),
            pageSize: String(query.pageSize),
            recordStatus: query.recordStatus,
            salesStatus: query.salesStatus,
            sort: query.sort,
            direction: query.direction
        });
        if (query.q)
            parameters.set('q', query.q);
        if (query.plan)
            parameters.set('plan', query.plan);
        return adminRequest(`/api/admin/customers/list.php?${parameters.toString()}`);
    },
    detail: (id) => adminRequest(`/api/admin/customers/detail.php?id=${encodeURIComponent(id)}`),
    lookup: (q = '', limit = 20) => {
        const parameters = new URLSearchParams({ limit: String(limit) });
        if (q)
            parameters.set('q', q);
        return adminRequest(`/api/admin/customers/lookup.php?${parameters.toString()}`);
    },
    create: (input) => withCsrf('/api/admin/customers/create.php', customerFields(input)),
    update: (id, version, input) => withCsrf('/api/admin/customers/update.php', {
        id,
        ...customerFields(input),
        version
    }),
    archive: (id, version) => withCsrf('/api/admin/customers/archive.php', {
        id,
        version
    }),
    restore: (id, version) => withCsrf('/api/admin/customers/restore.php', {
        id,
        version
    })
};
